var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72444 16.352L8.10831 12.2487L9.6562 14.223L6.67273 18.0171C5.53012 19.4689 3.41581 17.9389 4.72444 16.352ZM8.67636 7.00769C8.99863 5.95623 8.85052 5.05778 7.63955 3.72311L4.68049 0.163451C4.26056 -0.329726 3.27095 0.394576 3.68437 0.991921L6.05097 3.90703C6.49857 4.45066 5.66684 5.17008 5.20459 4.61017L2.75662 1.59578C2.30088 1.0733 1.35847 1.76342 1.83537 2.36077C2.52549 3.19087 3.59323 4.5467 4.28335 5.37679C4.76187 5.86346 4.03432 6.58451 3.5623 5.97739L1.13223 2.98253C0.775773 2.59515 0.193076 2.83604 0.0384502 3.28853C-0.12757 3.77194 0.280969 4.12514 0.559296 4.48322L3.27095 7.98591C4.11244 8.96087 5.05322 9.53868 6.147 9.21152C6.31465 9.16107 6.51973 9.05852 6.73946 8.92343L14.0248 18.328C14.4171 18.8342 15.1739 18.8879 15.6655 18.4793L15.7778 18.3866C16.3312 17.9259 16.4207 17.0844 15.947 16.5408L8.23201 7.67665C8.45663 7.426 8.62102 7.18836 8.67636 7.00769ZM10.7386 9.05852L11.9382 7.60341C10.3952 3.77845 16.1131 -1.31933 18.8849 1.02447C22.2525 3.87448 17.2475 10.7431 13.7302 9.0455L12.3093 10.8506L10.7386 9.05852Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.225d335c5807983bca0818f30b714c30.svg";
export { ForwardRef as ReactComponent };